import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './sbg-dynamic-share-price.component.scss';
import axios from 'axios';
var SbgDynamicSharePrice = /** @class */ (function (_super) {
    tslib_1.__extends(SbgDynamicSharePrice, _super);
    //containerMovement: any;
    function SbgDynamicSharePrice(element) {
        return _super.call(this, element) || this;
    }
    SbgDynamicSharePrice.prototype.init = function () {
        this.containerLoader = this.element.querySelector('.js-sbg-dynamic-share-price__loader');
        this.containerContent = this.element.querySelector('.js-sbg-dynamic-share-price__content');
        this.containerTitle = this.element.querySelector('.js-sbg-dynamic-share-price__title');
        this.containerNumber = this.element.querySelector('.js-sbg-dynamic-share-price__number');
        this.containerIcon = this.element.querySelector('.js-sbg-dynamic-share-price__icon');
        //this.containerMovement = this.element.querySelector('.js-sbg-dynamic-share-price__movement');
        this.apiSharePrice();
    };
    SbgDynamicSharePrice.prototype.bindEvents = function () {
    };
    SbgDynamicSharePrice.prototype.apiSharePrice = function () {
        var _this = this;
        var randomNumber = Math.floor(Math.random() * 100000) + 1;
        var url = "https://df.marketdata.feeds.iress.com/feed/2277/?token=eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJzZWNJRCI6NTMyLCJpYXQiOjE2ODUzNDg0MDMsImF1ZCI6ImlyZXNzLmNvLnphIiwiaXNzIjoiYWNjb3VudHMuaXJlc3MuY28uemEifQ._tcXkzJv1YmKZsaRCUMO0GpDsSYywo_QDuim7CKLQLqrGQSS8cFJZS2JeGfxt0B2yBnPkx6I4ou3KCwrSwEL2w";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        axios.get(url).then(function (response) {
            var json = response.data;
            _this.containerTitle.innerHTML = json.Snapshot[0].code;
            _this.containerNumber.innerHTML = _this.roundFormatterV2(parseFloat(json.Snapshot[0].trade), 0, true);
            // let movementNumber: any = parseFloat(json.Snapshot[0].movement)/100;
            // if(movementNumber < 0) {
            // 	this.containerIcon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="28" viewBox="0 0 24 28"><path fill="#D0021B" fill-rule="nonzero" d="M.5 16.35l1.627-1.65 8.714 8.834V0h2.302v23.534l8.73-8.85 1.627 1.65L11.992 28 .5 16.35"/></svg>`;
            // 	this.containerMovement.innerHTML = movementNumber;
            // }else{
            // 	this.containerIcon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="28" viewBox="0 0 24 28"><path fill="#00AD6C" fill-rule="nonzero" d="M.5 11.65l1.627 1.65 8.714-8.834V28h2.302V4.466l8.73 8.85 1.627-1.65L11.992 0 .5 11.65"></path></svg>`;
            // 	this.containerMovement.innerHTML = "+"+movementNumber;
            // }
            _this.containerLoader.classList.add('d-none');
            _this.containerContent.classList.remove('d-none');
        }).catch(function (error) {
            console.log(error);
        });
    };
    SbgDynamicSharePrice.prototype.roundFormatterV2 = function (expr, decplaces, formatted) {
        if (formatted === void 0) { formatted = false; }
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        var valueFull = str.substring(0, decpoint);
        var valueDecimal = str.substring(decpoint, str.length);
        if (formatted) {
            var lastTwo = valueFull.slice(-2);
            var orginalString = valueFull.substring(0, (valueFull.length - 2));
            valueFull = orginalString + '.' + lastTwo;
        }
        return valueFull;
    };
    return SbgDynamicSharePrice;
}(Base));
export { SbgDynamicSharePrice };



//////////////////
// WEBPACK FOOTER
// ./components/sbg-dynamic-share-price/sbg-dynamic-share-price.component.ts
// module id = 713
// module chunks = 0